/* istanbul ignore file */

export enum TriggerRelationship {
    And = 1,
    Or = 2,
}
